import { render, staticRenderFns } from "./History.vue?vue&type=template&id=2b1a3f13&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=2b1a3f13&lang=scss&scoped=true&"
import style1 from "./History.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a3f13",
  null
  
)

export default component.exports